import {
  StyledIconWrapper,
  StyledParagraph,
  StyledWrapper,
} from './HeroBanner.styles';
import { IHeroBannerProps } from './HeroBanner.types';
import { StyledH1 } from '../UI/Typography';

const HeroBanner = ({
  backgroundColor,
  color,
  icon,
  paragraph,
  title,
}: IHeroBannerProps): JSX.Element => {
  return (
    <StyledWrapper color={color} backgroundColor={backgroundColor}>
      <div>
        <StyledH1>{title}</StyledH1>
        <StyledParagraph>{paragraph}</StyledParagraph>
      </div>
      <StyledIconWrapper>{icon}</StyledIconWrapper>
    </StyledWrapper>
  );
};

export default HeroBanner;
